import { c as _c } from "react/compiler-runtime";
import { ActionIcon, Button, Center, Indicator, MantineTheme, Notification, Popover, rgba, useMantineTheme } from '@mantine/core';
import { HiBell } from 'react-icons/hi2';
import { sortBy } from 'remeda';
import { notNullOrEmpty, isNullOrEmpty } from 'shared/collection';
import { Markdown, useWindowDim } from 'shared/ui';
import { UseNotifyRow, useNotifys } from './useNotify';
import { SAvatar } from 'components/portal/SAvatar';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { match, P } from 'ts-pattern';
import { NotifyCommentCommon, NotifyCommentTypes } from './notifyTypes';
import { notifications } from '@mantine/notifications';
import { MdClear } from 'react-icons/md';
import { useHover } from '@mantine/hooks';
import { useState } from 'react';
import { nav } from 'components/portal/nav';
import { tourTipProps } from 'components/portal/tourTypes';
import { NotifyComment } from './NotifyComment';
export const Notifys = () => {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      showGlobalNotifications: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    notifys,
    opened,
    setOpened,
    clearAll,
    readAll,
    unread,
    loading
  } = useNotifys(t0);
  const {
    w
  } = useWindowDim();
  const t1 = Math.min(600, w);
  const t2 = unread ? unread : notifys?.length ?? 0;
  let t3;
  if ($[1] !== t2) {
    t3 = <b className="text-xs pointer-events-none ">{t2}</b>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = unread ? "primary" : "gray";
  const t5 = `pointer-events-none ${unread ? "opacity-100" : "opacity-30"}`;
  let t6;
  if ($[3] !== t5) {
    t6 = {
      indicator: t5
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== notifys) {
    t7 = isNullOrEmpty(notifys) ? {} : tourTipProps("notification-menu");
    $[5] = notifys;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== opened || $[8] !== readAll || $[9] !== setOpened) {
    t8 = () => {
      setOpened(!opened);
      readAll();
    };
    $[7] = opened;
    $[8] = readAll;
    $[9] = setOpened;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <HiBell size="20px" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t8) {
    t10 = <ActionIcon {...t7} onClick={t8}>{t9}</ActionIcon>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t11 = <Popover.Target><Indicator label={t3} color={t4} position="bottom-start" classNames={t6} size={14} offset={6}>{t10}</Indicator></Popover.Target>;
    $[15] = t10;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== notifys?.length) {
    t12 = notifys?.length === 0 && <Center className=" text-gray-400">No notifications</Center>;
    $[20] = notifys?.length;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== clearAll || $[23] !== loading || $[24] !== notifys || $[25] !== setOpened) {
    t13 = notNullOrEmpty(notifys) && <div className=""><div className="flex justify-end pb-2"><Button onClick={clearAll} leftSection={<MdClear />} loading={loading.clearAll}>Clear all</Button></div><div className="flex flex-col gap-2" onClick={() => setOpened(false)}>{sortBy(notifys, [_temp, "desc"]).map(_temp2)}</div></div>;
    $[22] = clearAll;
    $[23] = loading;
    $[24] = notifys;
    $[25] = setOpened;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <Popover.Dropdown className="max-h-[70vh] overflow-y-auto">{t12}{t13}</Popover.Dropdown>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== opened || $[31] !== setOpened || $[32] !== t1 || $[33] !== t11 || $[34] !== t14) {
    t15 = <Popover opened={opened} onChange={setOpened} width={t1} position="bottom-end" withArrow={true} shadow="md" withinPortal={false} closeOnClickOutside={true} closeOnEscape={true}>{t11}{t14}</Popover>;
    $[30] = opened;
    $[31] = setOpened;
    $[32] = t1;
    $[33] = t11;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export const NotifyItem = t0 => {
  const $ = _c(9);
  const {
    notify
  } = t0;
  const theme = useMantineTheme();
  let t1;
  if ($[0] !== notify || $[1] !== theme) {
    t1 = notifyProps({
      notify,
      inline: true,
      showDate: true,
      theme
    });
    $[0] = notify;
    $[1] = theme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let message;
  let props;
  if ($[3] !== t1) {
    ({
      message,
      ...props
    } = t1);
    $[3] = t1;
    $[4] = message;
    $[5] = props;
  } else {
    message = $[4];
    props = $[5];
  }
  let t2;
  if ($[6] !== message || $[7] !== props) {
    t2 = <Notification {...props}>{message}</Notification>;
    $[6] = message;
    $[7] = props;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export const notifyProps = (props: NotifyProps) => {
  const {
    inline,
    notify,
    theme
  } = props;
  const {
    cfg,
    read,
    id,
    workspace_id
  } = notify;
  const {
    color,
    title
  } = match(cfg).with({
    type: P.union(...NotifyCommentTypes.types)
  }, c => ({
    color: 'purple',
    title: <NotifyCommentLink notify={{
      workspace_id,
      ...c
    }} />
  })).with({
    type: 'tasked'
  }, t => ({
    color: 'blue',
    title: <div>
          You've been tasked on{' '}
          <Link href={nav.question.getUrl({
        question_id: t.question.id,
        workspace: workspace_id
      }).url}>
            {t.question.title}
          </Link>
        </div>
  })).with({
    type: P.union('question-notify', 'workspace-notify')
  }, t => ({
    color: 'blue',
    title: t.subject
  })).exhaustive();
  const cssColor = theme.colors[color]![5];
  return {
    id,
    color: read ? rgba(cssColor, 0.2) : cssColor,
    title,
    message: <NotifyMessage {...props} />,
    withCloseButton: !inline,
    styles: {
      root: {
        ...(inline ? {
          boxShadow: 'none',
          border: 'none'
        } : {})
      }
    },
    autoClose: inline ? undefined : 10000 // these are longer open because they aren't expected & have text in them
  }; //satisfies NotificationsProps
};
type NotifyProps = {
  notify: UseNotifyRow;
  inline?: boolean;
  showDate?: boolean;
  theme: MantineTheme;
};
const NotifyMessage = t0 => {
  const $ = _c(25);
  const {
    notify,
    inline,
    showDate
  } = t0;
  const {
    hovered,
    ref: hoverRef
  } = useHover();
  const [loadingClear, setLoadingClear] = useState(false);
  const {
    cfg,
    created_at,
    id
  } = notify;
  let t1;
  if ($[0] !== cfg) {
    t1 = match(cfg).with({
      type: P.union(...NotifyCommentTypes.types)
    }, _temp3).with({
      type: "tasked"
    }, _temp4).with({
      type: P.union("question-notify", "workspace-notify")
    }, _temp5).exhaustive();
    $[0] = cfg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    message
  } = t1;
  const t2 = `${hovered ? "" : "invisible"}`;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      variant: "subtle",
      size: "compact-sm",
      onMouseDown: _temp6,
      className: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const buttonProps = t3 satisfies React.ComponentProps<typeof Button<'button'>>;
  let t4;
  if ($[4] !== message) {
    t4 = <div className="max-h-16 grow overflow-y-auto overflow-x-clip">{message}</div>;
    $[4] = message;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== created_at || $[7] !== showDate) {
    t5 = showDate && <div className="text-sm text-gray-500">{DateTime.fromISO(created_at).toRelative()}</div>;
    $[6] = created_at;
    $[7] = showDate;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== id || $[10] !== inline || $[11] !== notify) {
    t6 = e_0 => {
      e_0.stopPropagation();
      setLoadingClear(true);
      notify.clear().finally(() => setLoadingClear(false));
      if (!inline) {
        notifications.hide(id);
      }
    };
    $[9] = id;
    $[10] = inline;
    $[11] = notify;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MdClear />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== buttonProps || $[15] !== loadingClear || $[16] !== t6) {
    t8 = <div className="flex"><Button {...buttonProps} loading={loadingClear} onClick={t6} leftSection={t7}>Clear</Button></div>;
    $[14] = buttonProps;
    $[15] = loadingClear;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <div className="flex items-center justify-between gap-1">{t5}{t8}</div>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== hoverRef || $[22] !== t4 || $[23] !== t9) {
    t10 = <div ref={hoverRef} className="mt-1 flex flex-col gap-1">{t4}{t9}</div>;
    $[21] = hoverRef;
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
const NotifyCommentLink = t0 => {
  const $ = _c(25);
  const {
    notify
  } = t0;
  const {
    question,
    subquestion,
    created_by,
    type
  } = notify;
  let t1;
  if ($[0] !== notify) {
    t1 = t => NotifyComment.link(t, notify, {
      external: false
    });
    $[0] = notify;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const link = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      root: {
        display: "inline-flex"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== created_by) {
    t3 = <SAvatar component="div" styles={t2} size="sm" profile={created_by} />;
    $[3] = created_by;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== link) {
    t4 = link("comment");
    $[5] = link;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== type) {
    t5 = NotifyCommentTypes.verb(type);
    $[7] = type;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Link href={t4}>{t5}</Link>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== type) {
    t7 = NotifyCommentTypes.relationToQuestion(type);
    $[12] = type;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <span className="px-1">{t7}</span>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== link || $[17] !== question.title || $[18] !== subquestion) {
    t9 = subquestion ? <><Link href={link("question")}>{question.title}</Link>{" / "}<Link href={link("subq")}>{subquestion.title}</Link></> : <Link href={link("question")}>{question.title}</Link>;
    $[16] = link;
    $[17] = question.title;
    $[18] = subquestion;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = <>{t3}{" "}{t6}{t8}{t9}</>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
function _temp(n) {
  return n.created_at;
}
function _temp2(n_0) {
  return <NotifyItem key={n_0.id} notify={n_0} />;
}
function _temp3(c) {
  return {
    message: <Markdown>{c.comment.cfg.text}</Markdown>
  };
}
function _temp4() {
  return {
    message: <></>
  };
}
function _temp5(t) {
  return {
    message: <Markdown>{t.msg}</Markdown>
  };
}
function _temp6(e) {
  return e.stopPropagation();
}